// import React from "react";
// import { VideoRecordinTaggingContent } from "../Components/VideoRecordinTaggingContent";

// const VideoRecordinAndTagging = () => {
//   return <VideoRecordinTaggingContent />;
// };

// export default VideoRecordinAndTagging;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { VideoRecordinTaggingContent } from "../Components/VideoRecordinTaggingContent";

const VideoRecordinAndTagging = () => {
  const seoData = getSEOData("/video-recording-tagging");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <VideoRecordinTaggingContent />
    </>
  );
};

export default VideoRecordinAndTagging;